import React from 'react';
import {
  ParkingIcon, GardenIcon, SwimmingPoolIcon, GymIcon, SecurityIcon,
  ElevatorIcon, BalconyIcon, HeatingIcon, ACIcon, HomeIcon,
  CheckIcon, BuildingIcon, PhoneIcon
} from '../Icons/Icons';
import './Amenities.css';

function Amenities({ amenities }) {
  const getAmenityIcon = (amenity) => {
    const iconProps = { size: 20, color: 'var(--color-primary)' };

    const iconMap = {
      'Parking': <ParkingIcon {...iconProps} />,
      'Garden': <GardenIcon {...iconProps} />,
      'Swimming Pool': <SwimmingPoolIcon {...iconProps} />,
      'Gym': <GymIcon {...iconProps} />,
      'Security': <SecurityIcon {...iconProps} />,
      'Elevator': <ElevatorIcon {...iconProps} />,
      'Balcony': <BalconyIcon {...iconProps} />,
      'Central Heating': <HeatingIcon {...iconProps} />,
      'Central AC': <ACIcon {...iconProps} />,
      'Furnished': <HomeIcon {...iconProps} />,
      'Nearby Mosque': <BuildingIcon {...iconProps} />,
      'Nearby School': <BuildingIcon {...iconProps} />,
      'Nearby Hospital': <BuildingIcon {...iconProps} />,
      'Nearby Market': <BuildingIcon {...iconProps} />,
      'Internet': <CheckIcon {...iconProps} />,
      'Cable TV': <CheckIcon {...iconProps} />,
      'Intercom': <PhoneIcon {...iconProps} />,
      'Servant Quarter': <HomeIcon {...iconProps} />,
      'Store Room': <HomeIcon {...iconProps} />,
      'Laundry Room': <HomeIcon {...iconProps} />
    };

    return iconMap[amenity] || <CheckIcon {...iconProps} />;
  };

  return (
    <div className="amenities-section">
      <h2 className="section-title">Amenities & Features</h2>

      <div className="amenities-grid">
        {amenities.map((amenity, index) => (
          <div key={index} className="amenity-item">
            <span className="amenity-icon">
              {getAmenityIcon(amenity)}
            </span>
            <span className="amenity-name">{amenity}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Amenities;
